import { PendingProspectStatus } from '../data/useGetPendingProspects';

export type PendingProspectsSearchFormValues = {
  status: PendingProspectStatus | '';
  customerId: string;
};

export const EMPTY_FILTERS: PendingProspectsSearchFormValues = {
  status: '',
  customerId: '',
};
